import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {
    UncontrolledDropdown, DropdownToggle, DropdownMenu, Nav, NavItem, NavLink,
} from 'reactstrap';
import { properties } from '../../constants/Propertise';
import { CSVLink } from "react-csv";

class PageTitle extends Component {

    render() {
        let {
            heading
        } = this.props;

        return (

            <div className="app-page-title" style={{marginTop : (this.props.style === true) ? '-50px': ''}}>
                <div className="page-title-wrapper">
                    <div className="page-title-heading">
                        <div>
                            {heading}
                        </div>
                    </div>
                    {
                        this.props.showButton === true &&
                        <div className="page-title-actions">
                            <Fragment>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle color="primary" className="btn-shadow" caret>
                                        {properties.actionsText}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        <Nav vertical>
                                            <NavItem>
                                                <NavLink onClick={this.props.doActions}>
                                                    <i className="nav-link-icon pe-7s-plus"> </i>
                                                    <span>{properties.addText}</span>
                                                </NavLink>
                                            </NavItem>
                                            {
                                                this.props.downloadData.length > 0 &&
                                                <NavItem>
                                                    <span className="nav-link">
                                                        <i className="nav-link-icon pe-7s-download"> </i>
                                                        <span>
                                                            <CSVLink
                                                                data={this.props.downloadData}
                                                                filename={this.props.fileName+'.csv'}
                                                                className='hiddencsvButton'
                                                                headers = {this.props.headers}
                                                            >
                                                                {properties.exportText}
                                                            </CSVLink>
                                                        </span>
                                                    </span>
                                                </NavItem>
                                            }
                                        </Nav>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </Fragment>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    enablePageTitleIcon: state.ThemeOptions.enablePageTitleIcon,
    enablePageTitleSubheading: state.ThemeOptions.enablePageTitleSubheading,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PageTitle);